module.exports = __webpack_public_path__ + "static/media/clickhereMobile.f4b8d6d6.png";